import { useState, type FormEvent } from "react";
import Dialog from "../Dialog";
import { parseMoney, type StageId } from "../../crm";
import MoneyInput from "./MoneyInput";
import type { Deal } from "./types";

/** Won asks for the contract amount; Lost asks why (optional). Cancel leaves the deal where it was. */
export default function CloseDialog({ pending, onCancel, onConfirm }: { pending: { deal: Deal; stage: StageId }; onCancel: () => void; onConfirm: (extra: Record<string, unknown>) => void }) {
  const won = pending.stage === "won";
  const [value, setValue] = useState("");
  const [error, setError] = useState("");
  function submit(e: FormEvent) {
    e.preventDefault();
    if (won) {
      const cents = parseMoney(value);
      if (!cents) { setError("Enter the contract amount in dollars, like 12,500."); return; }
      onConfirm({ value_cents: cents });
    } else onConfirm({ lost_reason: value.trim() });
  }
  return (
    <Dialog title={won ? `Won: ${pending.deal.title}` : `Lost: ${pending.deal.title}`} onClose={onCancel}>
      <form className="operation-form crm-close-form" onSubmit={submit}>
        {won ? (
          <label>Contract amount<MoneyInput value={value} onChange={(v) => { setValue(v); setError(""); }} placeholder="12,500" autoFocus /></label>
        ) : (
          <label><span>Reason <span className="crm-muted">Optional</span></span><textarea rows={3} value={value} onChange={(e) => setValue(e.target.value)} maxLength={500} placeholder="Went with another agency, budget, timing" /></label>
        )}
        {error && <p className="crm-error" role="alert">{error}</p>}
        <div className="operation-actions">
          <button type="button" className="button secondary" onClick={onCancel}>Cancel</button>
          <button type="submit" className="button">{won ? "Mark won" : "Mark lost"}</button>
        </div>
      </form>
    </Dialog>
  );
}

